/**
 * TeflisLogo.jsx
 * Path: frontend/src/components/TeflisLogo.jsx
 * Description: Wspolny komponent logo Teflis ladowanego z publicznych zasobow aplikacji.
 * Related: components/AppShell.jsx, pages/LoginPage.jsx
 */

export default function TeflisLogo({ className = "", alt = "Teflis" }) {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/teflis-logo.png`}
      alt={alt}
      className={className}
      loading="eager"
      decoding="async"
    />
  );
}
